import React, { useMemo } from "react";
const { compose, withProps } = require("recompose");
const {
  withGoogleMap,
  GoogleMap,
  StreetViewPanorama
} = require("react-google-maps");

function StreetViewPanormaWithAnOverlayView(props) {
    var heading = props.heading;
    const StreetViewPanormaCustom = compose(
        withProps({
          googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${props.apiKey}&v=3.exp&libraries=geometry,drawing,places`,
          loadingElement: <div style={{ height: `100%` }} />,
          containerElement: <div style={{ height: `calc(100vh - 230px)` }} />,
          mapElement: <div style={{ height: `100%` }} />,
          center: { lat:props.lat, lng: props.lng },
        }),
        withGoogleMap
      )(props =>
        <GoogleMap defaultZoom={8} defaultCenter={props.center}>
          <StreetViewPanorama defaultPosition={props.center} visible pov={{ heading: heading, pitch: 0 }}>
          </StreetViewPanorama>
        </GoogleMap>
      );

    return useMemo(() => (
        <StreetViewPanormaCustom></StreetViewPanormaCustom>
    ), [props.heading]);
}

export default StreetViewPanormaWithAnOverlayView;